import {Controller, useFormContext} from "react-hook-form";
import Select from "react-select";

const BANK_OPTIONS = [
  'BCA',
  'BRI',
  'MANDIRI',
  'OTHERS'
]
const renderBankSelectOptions = () => BANK_OPTIONS.map(b => ({
  value: b,
  label: b
}))

interface BankInputProps {
  selectedBank: { label: string, value: string } | null
}

const BankInput: React.FC<BankInputProps> = ({ selectedBank }) => {
  const { control, register } = useFormContext()

  return (
    <>
      <div className="j-col gap-2">
        <div className="text-jsm font-medium">Bank</div>
        <Controller
          name="customer_info.bank_code"
          control={control}
          render={({field}) => <Select
            id="venueId"
            placeholder="Pilih Bank"
            options={renderBankSelectOptions()}
            value={selectedBank}
            onChange={(e) => {
              field.onChange(e.value)
            }}
          />}
        />
      </div>
      <div className="j-col gap-2">
        <div className="text-jsm font-medium">Account Number
        </div>
        <div>
          <input
            {...register('customer_info.account_number')}
            name="customer_info.account_number"
            type="number"
            className="flex w-full items-center py-[8px] px-4 gap-2 border rounded border-solid border-stroke-subtle text-jsm font-normal"
            placeholder="Account number"/>
        </div>
      </div>
      <div className="j-col gap-2">
        <div className="text-jsm font-medium">Name</div>
        <div>
          <input
            {...register('customer_info.account_name')}
            name="customer_info.account_name"
            type="text"
            className="flex w-full items-center py-[8px] px-4 gap-2 border rounded border-solid border-stroke-subtle text-jsm font-normal"
            placeholder="Account name"/>
        </div>
      </div>
    </>
  );
};

export default BankInput;